// Variante Rosace (dev) — utilisée via fileReplacements (configurations
// `rosace` / `serve:rosace` dans angular.json). Doit garder exactement les
// mêmes propriétés que environment.ts pour que le build compile.
// pageFormJsonId = 0 : questionnaire FUTÉ désactivé (Losange uniquement).

export const environment = {
  production: false,
  apiUrl: 'https://dev.auth.api.fibre.services/api',
  reseau: 'rosace',
  brandName: 'Rosace',
  siteUrl: 'https://www.rosace-fibre.fr',
  vdrUrl: 'https://viedureseau.rosace-fibre.fr',
  gtagId: 'G-RYB5MD3GVX',
  logo: '/assets/logo_rosace2024.png',
  logoFond: '/assets/logo_rosace2024_FOND.jpg',
  favicon: 'assets/icon/favicon.rosace.jpg',
  project_id: 4,
  pageInformationId: 2,
  logGF: '',
  passGF: '',
  tinyMceKey: 'tsykhqqr6dn99vcf6bwz10y103pgzhiod0cygfqaasz0hrz1',
  // DEV
  pageDocumentationId: 5,
  pageFormJsonId: 0,
  pageDocumentationCuivreId: 10,
  pageVideoId: 12,
  // Page "En savoir plus GFU"
  gfuInfoUrl: 'https://www.rosace-fibre.fr/wp-content/uploads/2024/12/Presentation-Rosace-GFU.pdf',
  // Carte "contact" de l'espace GFU : true = page interne contacts, false = gfuContactUrl
  gfuContactPage: true,
  gfuContactUrl: '',
  // Palette de marque (injectée sur :root au bootstrap — variables.scss = défaut)
  palette: {
    blue: '#e02130',
    blueRgb: '224, 33, 48',
    blueHover: '#eb414f',
    blue2: '#ce1928',
    homeTitle: '#333333',
    gfusBannerBg: '#e02130',
    homeIconBg: '#b51723',
    contactItemBg: '#d52230',
    globalBoxBg: '#b93b45',
    globalBoxHover: '#c14852',
    fileUploadBtnBg: '#c60000',
    fileUploadBtnHover: '#d30909',
    sectionTitle: '#333333',
    btnDisabledBg: '#d38e93',
  },

  // Firebase Configuration
  firebase: {
    apiKey: "AIzaSyC8qtcnGTEWxciWX5qlIh002H4-BlMq7Xc",
    authDomain: "grand-est-rosace-9ecff.firebaseapp.com",
    projectId: "grand-est-rosace-9ecff",
    storageBucket: "grand-est-rosace-9ecff.firebasestorage.app",
    messagingSenderId: "993093562564",
    appId: "1:993093562564:web:4cdad0d71ef8e998175991",
    measurementId: "G-RYB5MD3GVX"
  },

  enableAnalytics: true,
  debugAnalytics: true  // Activer le mode debug en développement
};
